import { render, staticRenderFns } from "./DateSeparator.vue?vue&type=template&id=3b940cf9&scoped=true&"
import script from "./DateSeparator.vue?vue&type=script&lang=js&"
export * from "./DateSeparator.vue?vue&type=script&lang=js&"
import style0 from "./DateSeparator.vue?vue&type=style&index=0&id=3b940cf9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b940cf9",
  null
  
)

export default component.exports